/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';

/**
 * 
 * @export
 * @interface CreateNaturalPersonCommandDto
 */
export interface CreateNaturalPersonCommandDto {
    /**
     * Optional identifier for the person
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    id?: string;
    /**
     * Identifier for the person's civility/title
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    civilityId: string;
    /**
     * Date of birth of the person
     * @type {Date}
     * @memberof CreateNaturalPersonCommandDto
     */
    birthDate: Date;
    /**
     * Last name of the person
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    lastName: string;
    /**
     * First name of the person
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    firstName: string;
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof CreateNaturalPersonCommandDto
     */
    address: CreateAddressDto;
    /**
     * French phone number
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    phone: string;
    /**
     * Email address of the person
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    email: string;
    /**
     * Birth name if different from current last name
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    birthName?: string;
    /**
     * Identifier for the birth country
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    birthCountryId: string;
    /**
     * Identifier for the tax residence country
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    taxResidenceCountryId: string;
    /**
     * Identifier for the nationality
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    nationalityId: string;
    /**
     * Indicates if the person is a Politically Exposed Person
     * @type {boolean}
     * @memberof CreateNaturalPersonCommandDto
     */
    isPPE: boolean;
    /**
     * Indicates if the person is a Politically Exposed Person
     * @type {boolean}
     * @memberof CreateNaturalPersonCommandDto
     */
    isFPE?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    companyRole?: string;
    /**
     * OrganizationUnit (ABP) to attach the person to. Used by admins when creating a
     * subscriber on behalf of a target plateforme — the entity becomes visible to that
     * plateforme's corporate managers. If omitted, the current user's plateforme is used.
     * 
     * @type {string}
     * @memberof CreateNaturalPersonCommandDto
     */
    plateformeId?: string | null;
}

/**
 * Check if a given object implements the CreateNaturalPersonCommandDto interface.
 */
export function instanceOfCreateNaturalPersonCommandDto(value: object): value is CreateNaturalPersonCommandDto {
    if (!('civilityId' in value) || value['civilityId'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('birthCountryId' in value) || value['birthCountryId'] === undefined) return false;
    if (!('taxResidenceCountryId' in value) || value['taxResidenceCountryId'] === undefined) return false;
    if (!('nationalityId' in value) || value['nationalityId'] === undefined) return false;
    if (!('isPPE' in value) || value['isPPE'] === undefined) return false;
    return true;
}

export function CreateNaturalPersonCommandDtoFromJSON(json: any): CreateNaturalPersonCommandDto {
    return CreateNaturalPersonCommandDtoFromJSONTyped(json, false);
}

export function CreateNaturalPersonCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNaturalPersonCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'civilityId': json['civilityId'],
        'birthDate': (new Date(json['birthDate'])),
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'address': CreateAddressDtoFromJSON(json['address']),
        'phone': json['phone'],
        'email': json['email'],
        'birthName': json['birthName'] == null ? undefined : json['birthName'],
        'birthCountryId': json['birthCountryId'],
        'taxResidenceCountryId': json['taxResidenceCountryId'],
        'nationalityId': json['nationalityId'],
        'isPPE': json['isPPE'],
        'isFPE': json['isFPE'] == null ? undefined : json['isFPE'],
        'companyRole': json['companyRole'] == null ? undefined : json['companyRole'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
    };
}

export function CreateNaturalPersonCommandDtoToJSON(json: any): CreateNaturalPersonCommandDto {
    return CreateNaturalPersonCommandDtoToJSONTyped(json, false);
}

export function CreateNaturalPersonCommandDtoToJSONTyped(value?: CreateNaturalPersonCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'civilityId': value['civilityId'],
        'birthDate': ((value['birthDate']).toISOString()),
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'address': CreateAddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'email': value['email'],
        'birthName': value['birthName'],
        'birthCountryId': value['birthCountryId'],
        'taxResidenceCountryId': value['taxResidenceCountryId'],
        'nationalityId': value['nationalityId'],
        'isPPE': value['isPPE'],
        'isFPE': value['isFPE'],
        'companyRole': value['companyRole'],
        'plateformeId': value['plateformeId'],
    };
}

